<template>
  <el-table-column
    prop="location.value"
    sortable="custom"
    label="Terület"
    show-overflow-tooltip
    min-width="130"
  >
    <template slot-scope="scope">
      {{ scope.row.location_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'location.value',
  };
</script>
